import { Component, EventEmitter, inject, Input, OnInit, Output } from '@angular/core';
import { httpsCallable } from 'firebase/functions';
import { GroupRenderData } from '../../services/firebase.model';
import { SkeletonModule } from 'primeng/skeleton';
import { TooltipModule } from 'primeng/tooltip';
import { CommonModule } from '@angular/common';
import { ButtonModule } from 'primeng/button';
import { SplitButtonModule } from 'primeng/splitbutton';
import { MenuItem } from 'primeng/api';
import { FirebaseFunctionService } from '../../services/firebase-function.service';


@Component({
  selector: 'app-render-card',
  standalone: true,
  imports: [
    TooltipModule,
    SkeletonModule,
    CommonModule,
    ButtonModule,
    SplitButtonModule,
  ],
  templateUrl: './render-card.component.html',
  styleUrl: './render-card.component.scss',
})
export class RenderCardComponent implements OnInit {
  functions = inject(FirebaseFunctionService)
  @Input() renderData: GroupRenderData

  @Output() move = new EventEmitter()
  @Output() delete = new EventEmitter()
  @Output() open = new EventEmitter()
  @Output() comments = new EventEmitter()
  @Output() clone = new EventEmitter()

  loaded = false

  menuItems: MenuItem[] = [
    {
      icon: 'pi pi-trash',
      label: 'Delete',
      command: () => {
        this.delete.emit()
      }
    },
    {
      icon: 'pi pi-clone',
      label: 'Clone',
      command: () => {
        this.clone.emit()
      }
    },
    {
      icon: 'pi fi fi-rr-file-export',
      label: 'Move',
      command: () => {
        this.move.emit()
      }
    }
  ]


  onLoaded() {
    this.loaded = true
  }

  ngOnInit() {
    if (Date.now() > this.renderData.thumbnailExpiration) {
      httpsCallable(this.functions.functions, 'refreshGroupThumbnail')({
        renderId: this.renderData.id
      })
    }
  }
}
